import React, { createContext, useContext } from 'react';
import { useBureauSignalR } from '../hooks/useBureauSignalR';
import type { BureauAlarmNotification } from '../hooks/useBureauSignalR';

interface BureauSignalRContextType {
  lastNotification: BureauAlarmNotification | null;
  isConnected: boolean;
  subscribe: (callback: (n: BureauAlarmNotification) => void) => () => void;
}

const BureauSignalRContext = createContext<BureauSignalRContextType | undefined>(undefined);

export const BureauSignalRProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const value = useBureauSignalR();
  return (
    <BureauSignalRContext.Provider value={value}>
      {children}
    </BureauSignalRContext.Provider>
  );
};

/**
 * Use single shared SignalR connection for bureau/CSH alarm notifications.
 */
export function useBureauSignalRContext(): BureauSignalRContextType {
  const ctx = useContext(BureauSignalRContext);
  if (!ctx) {
    throw new Error('useBureauSignalRContext must be used within a BureauSignalRProvider');
  }
  return ctx;
}
